(() => {
   let switchers = document.querySelectorAll(".js-languages");

   switchers.forEach(s => {
      s.addEventListener("change", e => {
         let url = s.options[s.selectedIndex].dataset.url;
         window.location.href = url;
    })
   });
   
})();